var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";

import * as types from "../utils/types";

import { orderProperties, retrieveSchema, getDefaultRegistry, getUiOptions, ADDITIONAL_PROPERTY_FLAG } from "../utils/";

function DefaultObjectFieldTemplate(props) {
    var canExpand = function canExpand() {
        var formData = props.formData,
            schema = props.schema,
            uiSchema = props.uiSchema;

        if (!schema.additionalProperties) {
            return false;
        }

        var _getUiOptions = getUiOptions(uiSchema),
            expandable = _getUiOptions.expandable;

        if (expandable === false) {
            return expandable;
        }
        // if ui:options.expandable was not explicitly set to false, we can add
        // another property if we have not exceeded maxProperties yet
        if (schema.maxProperties !== undefined) {
            return Object.keys(formData).length < schema.maxProperties;
        }
        return true;
    };

    return props.properties.map(function (prop) {
        return prop.content;
    });

    /*
       const { TitleField, DescriptionField } = props;
       return (
      <fieldset id={props.idSchema.$id}>
        {(props.uiSchema["ui:title"] || props.title) && (
          <TitleField
            id={`${props.idSchema.$id}__title`}
            title={props.title || props.uiSchema["ui:title"]}
            required={props.required}
            formContext={props.formContext}
          />
        )}
        {props.description && (
          <DescriptionField
            id={`${props.idSchema.$id}__description`}
            description={props.description}
            formContext={props.formContext}
          />
        )}
        {props.properties.map(prop => prop.content)}
        {canExpand() && (
          <ButtonAdd
            className="object-property-expand"
            onClick={props.onAddClick(props.schema)}
            disabled={props.disabled || props.readonly}
          />
        )}
      </fieldset>
    );
    
    */
}

var ObjectField = (_temp2 = _class = function (_Component) {
    _inherits(ObjectField, _Component);

    function ObjectField() {
        var _temp, _this, _ret;

        _classCallCheck(this, ObjectField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            additionalProperties: {}
        }, _this.onPropertyChange = function (name) {
            var addedByAdditionalProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


            //        console.log('object:onPropertyChange', name);            

            var schema = _this.props.schema;


            return function (formData, errorSchema) {
                var _extends2, _extends3;

                if (!formData && addedByAdditionalProperties) {
                    // Don't set value = undefined for fields added by
                    // additionalProperties. Doing so removes them from the
                    // formData, which causes them to completely disappear
                    // (including the input field for the property name). Unlike
                    // fields which are "mandated" by the schema, these fields can
                    // be set to undefined by clicking a "delete field" button, so
                    // set empty values to the empty string.
                    formData = "";
                }
                var newFormData = _extends({}, _this.props.formData, (_extends2 = {}, _extends2[name] = formData, _extends2));

                // set _action prop

                if (schema.properties.hasOwnProperty('_action')) {

                    if (newFormData._action !== "delete" && newFormData._action !== "create") {
                        newFormData._action = "update";
                    }
                }

                _this.props.onChange(newFormData, errorSchema && _this.props.errorSchema && _extends({}, _this.props.errorSchema, (_extends3 = {}, _extends3[name] = errorSchema, _extends3)));
            };
        }, _this.onDropPropertyClick = function (key) {
            return function (event) {
                event.preventDefault();
                var _this$props = _this.props,
                    onChange = _this$props.onChange,
                    formData = _this$props.formData;

                var copiedFormData = _extends({}, formData);
                delete copiedFormData[key];
                onChange(copiedFormData);
            };
        }, _this.getAvailableKey = function (preferredKey, formData) {
            var index = 0;
            var newKey = preferredKey;
            while (formData.hasOwnProperty(newKey)) {
                newKey = preferredKey + "-" + ++index;
            }
            return newKey;
        }, _this.onKeyChange = function (oldValue) {

            //        console.log('object:onKeyChange', oldValue);            

            return function (value, errorSchema) {
                var _newKeys, _extends4;

                if (oldValue === value) {
                    return;
                }
                value = _this.getAvailableKey(value, _this.props.formData);
                var newFormData = _extends({}, _this.props.formData);
                var newKeys = (_newKeys = {}, _newKeys[oldValue] = value, _newKeys);
                var keyValues = Object.keys(newFormData).map(function (key) {
                    var _ref;

                    var newKey = newKeys[key] || key;
                    return _ref = {}, _ref[newKey] = newFormData[key], _ref;
                });
                var renamedObj = Object.assign.apply(Object, [{}].concat(keyValues));
                _this.props.onChange(renamedObj, errorSchema && _this.props.errorSchema && _extends({}, _this.props.errorSchema, (_extends4 = {}, _extends4[value] = errorSchema, _extends4)));
            };
        }, _this.handleAddClick = function (schema) {
            return function () {
                var type = schema.additionalProperties.type;
                var newFormData = _extends({}, _this.props.formData);
                newFormData[_this.getAvailableKey("newKey", newFormData)] = _this.getDefaultValue(type);
                _this.props.onChange(newFormData);
            };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ObjectField.prototype.isRequired = function isRequired(name) {
        var schema = this.props.schema;
        return Array.isArray(schema.required) && schema.required.indexOf(name) !== -1;
    };

    ObjectField.prototype.getDefaultValue = function getDefaultValue(type) {
        switch (type) {
            case "string":
                return "New Value";
            case "array":
                return [];
            case "boolean":
                return false;
            case "null":
                return null;
            case "number":
                return 0;
            case "object":
                return {};
            default:
                // We don't have a datatype for some reason (perhaps additionalProperties was true)
                return "New Value";
        }
    };

    ObjectField.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            uiSchema = _props.uiSchema,
            formData = _props.formData,
            errorSchema = _props.errorSchema,
            idSchema = _props.idSchema,
            name = _props.name,
            required = _props.required,
            disabled = _props.disabled,
            readonly = _props.readonly,
            idPrefix = _props.idPrefix,
            onBlur = _props.onBlur,
            onFocus = _props.onFocus,
            _props$registry = _props.registry,
            registry = _props$registry === undefined ? getDefaultRegistry() : _props$registry;
        var definitions = registry.definitions,
            fields = registry.fields,
            formContext = registry.formContext;
        var SchemaField = fields.SchemaField,
            TitleField = fields.TitleField,
            DescriptionField = fields.DescriptionField;

        var schema = retrieveSchema(this.props.schema, definitions, formData);
        var title = schema.title === undefined ? name : schema.title;
        var description = uiSchema["ui:description"] || schema.description;
        var orderedProperties = void 0;
        try {
            var properties = Object.keys(schema.properties || {});
            orderedProperties = orderProperties(properties, uiSchema["ui:order"]);
        } catch (err) {
            return React.createElement(
                "div",
                null,
                React.createElement(
                    "p",
                    { className: "config-error", style: { color: "red" } },
                    "Invalid ",
                    name || "root",
                    " object field configuration:",
                    React.createElement(
                        "em",
                        null,
                        err.message
                    ),
                    "."
                ),
                React.createElement(
                    "pre",
                    null,
                    JSON.stringify(schema)
                )
            );
        }

        var Template = registry.ObjectFieldTemplate || DefaultObjectFieldTemplate;
        var templateProps = {
            title: uiSchema["ui:title"] || title,
            description: description,
            TitleField: TitleField,
            DescriptionField: DescriptionField,
            properties: orderedProperties.map(function (name) {
                var addedByAdditionalProperties = schema.properties[name].hasOwnProperty(ADDITIONAL_PROPERTY_FLAG);
                return {
                    content: React.createElement(SchemaField, {
                        key: name,
                        name: name,
                        required: _this2.isRequired(name),
                        schema: schema.properties[name],
                        uiSchema: addedByAdditionalProperties ? uiSchema.additionalProperties : uiSchema[name],
                        errorSchema: errorSchema[name],
                        idSchema: idSchema[name],
                        idPrefix: idPrefix,
                        formData: (formData || {})[name],
                        onKeyChange: _this2.onKeyChange(name),
                        onChange: _this2.onPropertyChange(name, addedByAdditionalProperties),
                        onBlur: onBlur,
                        onFocus: onFocus,
                        registry: registry,
                        disabled: disabled,
                        readonly: readonly,
                        onDropPropertyClick: _this2.onDropPropertyClick
                    }),
                    name: name,
                    readonly: readonly,
                    disabled: disabled,
                    required: required
                };
            }),
            readonly: readonly,
            disabled: disabled,
            required: required,
            idSchema: idSchema,
            uiSchema: uiSchema,
            schema: schema,
            formData: formData,
            formContext: formContext
        };
        return React.createElement(Template, _extends({}, templateProps, { onAddClick: this.handleAddClick }));
    };

    return ObjectField;
}(Component), _class.defaultProps = {
    uiSchema: {},
    formData: {},
    errorSchema: {},
    idSchema: {},
    required: false,
    disabled: false,
    readonly: false
}, _temp2);


if (process.env.NODE_ENV !== "production") {
    ObjectField.propTypes = process.env.NODE_ENV !== "production" ? types.fieldProps : {};
}

export default ObjectField;